import { render, staticRenderFns } from "./clientConfig.vue?vue&type=template&id=cae9049c&scoped=true&"
import script from "./clientConfig.vue?vue&type=script&lang=js&"
export * from "./clientConfig.vue?vue&type=script&lang=js&"
import style0 from "./clientConfig.vue?vue&type=style&index=0&id=cae9049c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae9049c",
  null
  
)

export default component.exports